module.exports = __webpack_public_path__ + "static_pc/img/ba12.778ea6d1.png";